import React, { useState, useEffect } from 'react';
import './Nav.css';

function Nav() {
    const [show, handleShow] = useState(false);

    useEffect(() => {
        window.addEventListener("scroll", () => {
            window.scrollY > 100 ? handleShow(true) : handleShow(false)
        });
        return () => {window.removeEventListener("scroll", null)};
    }, [])
    return (
        <div className={`nav ${show && 'nav_black'}`}>
            <div className="nav_imgs">
                <img 
                    src="https://upload.wikimedia.org/wikipedia/commons/0/08/Netflix_2015_logo.svg" 
                    alt="Netflix logo" 
                    className="netflix_logo" 
                />
                <img 
                    src="https://upload.wikimedia.org/wikipedia/commons/0/0b/Netflix-avatar.png" 
                    alt="Account" 
                    className="account" 
                />
            </div>
        </div>
    )
}

export default Nav